let config = window.bsrs_config || {}
config.apiGatewayUrl = '/'
module.exports = config



// WEBPACK FOOTER //
// ./src/config.js